<template>
    <b-modal
        lazy
        title-tag="h2"
        :title="isAbaxis ? 'Cancel Test' : 'Delete Record'"
        :visible="isOpen"
    >
        <InvoiceInPaymentWarning
            :invoiceId="invoiceIdLabProfile"
            module="medical-record"
        />

        <p v-if="isAbaxis">
            Deleting this record will also cancel the test order that is pending
            with the analyzer. Do you wish to delete this record?
        </p>
        <p v-else>
            Deleting this record will also delete all related charges (which
            will impact historical billing records), reminders, letters, and forms. Do
            you wish to delete this record?
        </p>

        <div slot="modal-footer" class="w-100">
            <modal-footer
                okTitle="Delete"
                :isLoading="loading"
                :isDisabled="isHasUsersChooseInvoice"
                @ok-action="deleteRecord"
                @cancel-action="isOpen = false"
            />
        </div>
    </b-modal>
</template>

<script type="text/javascript">
import History from "@/services/patient-history";
import PatientLab from "@/services/patient/patient-lab";
import { isEmpty } from "lodash";
export default {
    components: {
        ModalFooter: () => import("@/components/elements/modal-footer"),
        InvoiceInPaymentWarning: () =>
            import("@/components/invoice/invoice-in-payment-warning")
    },
    data() {
        return {
            loading: false,
            isOpen: false,
            record: null
        };
    },
    props: {
        patientId: {
            type: String
        }
    },
    computed: {
        isAbaxis() {
            return this.record ? this.record.isAbaxis : false;
        },
        invoiceIdLabProfile() {
            return this.$store.getters["billing/invoiceIdLabProfile"];
        },
        isHasUsersChooseInvoice() {
            return this.invoiceIdLabProfile
                ? !isEmpty(
                      this.$store.getters["billing/findUserChooseInvoice"](
                          this.invoiceIdLabProfile
                      )
                  )
                : false;
        }
    },
    methods: {
        open(record) {
            this.getDetails(record);
        },
        getDetails(record) {
            History.getRecordDetails(record.id)
                .then(response => {
                    if (response.message.code == 200) {
                        this.record = response.resource;
                        this.isOpen = true;
                    } else {
                        this._message(
                            "Error : Unable to get record details",
                            "danger"
                        );
                    }
                })
                .catch(error => {
                    this._message(
                        "Error : Unable to get record details",
                        "danger"
                    );
                    console.error(error);
                });
        },
        async deleteRecord() {
            this.loading = true;
            PatientLab.deleteRecordLab(this.record.id)
                .then(response => {
                    this._message(response.message);
                    this.$emit("reload");

                    // to reload the reminder summary when the record has reminders
                    this.$store.dispatch(
                        "patient/getReminders",
                        this.patientId
                    );

                    this.isOpen = false;
                    this.loading = false;
                })
                .catch(error => {
                    this._message("Error : Unable to delete record", "danger");
                    console.error(error);
                    this.loading = false;
                });
        }
    }
};
</script>
